const $063969238f3d5243$var$nextFrame = ()=>{
    return new Promise((resolve)=>{
        requestAnimationFrame(()=>{
            requestAnimationFrame(resolve);
        });
    });
};
const $063969238f3d5243$var$afterTransition = (element)=>{
    return new Promise((resolve)=>{
        const firstDuration = getComputedStyle(element).transitionDuration.split(",")[0].trim();
        const value = Number.parseFloat(firstDuration);
        const duration = firstDuration.endsWith("ms") ? value : value * 1000;
        setTimeout(resolve, duration);
    });
};
const $063969238f3d5243$var$selectInGroup = (buttons, picked)=>{
    buttons.forEach((button)=>{
        const active = button === picked;
        button.classList.toggle("selected", active);
        button.setAttribute("aria-pressed", active ? "true" : "false");
    });
};
const $063969238f3d5243$var$pickedName = (buttons)=>{
    const picked = buttons.find((button)=>button.classList.contains("selected"));
    const label = picked?.querySelector("p");
    return label === null || label === undefined ? "" : label.textContent.trim();
};
// Button labels ("New York", "Neon Green") map to D0 render file slugs
// ("new-york", "neon-green").
const $063969238f3d5243$var$slug = (text)=>text.toLowerCase().replace(/\s+/g, "-");
const $063969238f3d5243$export$562f18a610c65bb7 = async ()=>{
    // Two phones below xl share the wallpaper via class (lock + home on xl).
    const wallpapers = [
        ...document.querySelectorAll(".playground-wallpaper")
    ];
    const combo = document.querySelector("#playground-combo");
    const lockOverlay = document.querySelector("#playground-lock");
    const homeOverlay = document.querySelector("#playground-home");
    const locationPicks = [
        ...document.querySelectorAll(".playground-location")
    ];
    const stylePicks = [
        ...document.querySelectorAll(".playground-style")
    ];
    const screenButtons = [
        ...document.querySelectorAll(".playground-screen-button")
    ];
    if (wallpapers.length === 0 || locationPicks.length === 0 || stylePicks.length === 0) return;
    // Slice 2 fix: combo URLs come from the hidden preload block in HTML, where
    // Parcel has rewritten them to the hashed dist paths — JS must never
    // construct asset paths itself. (The block also preloads all 16 natively.)
    const comboSrc = {};
    document.querySelectorAll(".playground-preload img").forEach((img)=>{
        comboSrc[img.dataset.combo] = img.src;
    });
    const renderCombo = async ()=>{
        const key = `${$063969238f3d5243$var$slug($063969238f3d5243$var$pickedName(locationPicks))}-${$063969238f3d5243$var$slug($063969238f3d5243$var$pickedName(stylePicks))}`;
        const target = comboSrc[key];
        if (combo !== null) combo.textContent = `${$063969238f3d5243$var$pickedName(locationPicks)} + ${$063969238f3d5243$var$pickedName(stylePicks)}`;
        if (target === undefined) return;
        await Promise.all(wallpapers.map(async (wallpaper)=>{
            if (wallpaper.src === target) return;
            wallpaper.classList.add("is-fading");
            await $063969238f3d5243$var$afterTransition(wallpaper);
            wallpaper.src = target;
            await $063969238f3d5243$var$nextFrame();
            wallpaper.classList.remove("is-fading");
        }));
    };
    locationPicks.forEach((pick)=>{
        pick.addEventListener("click", ()=>{
            $063969238f3d5243$var$selectInGroup(locationPicks, pick);
            renderCombo();
        });
    });
    stylePicks.forEach((pick)=>{
        pick.addEventListener("click", ()=>{
            $063969238f3d5243$var$selectInGroup(stylePicks, pick);
            renderCombo();
        });
    });
    screenButtons.forEach((button)=>{
        button.addEventListener("click", ()=>{
            $063969238f3d5243$var$selectInGroup(screenButtons, button);
            const showLock = button.dataset.screen !== "home";
            if (lockOverlay !== null) lockOverlay.hidden = !showLock;
            if (homeOverlay !== null) homeOverlay.hidden = showLock;
        });
    });
    // On xl both phones are visible side by side (toggle is hidden), so force
    // the lock phone back to its lock state — a mobile toggle to home must not
    // leak into the dual-phone view on resize. Breakpoint read from the theme
    // so JS tracks the xl: utilities in CSS instead of duplicating the value.
    const xl = getComputedStyle(document.documentElement).getPropertyValue("--breakpoint-xl").trim() || "1280px";
    const wide = window.matchMedia(`(min-width: ${xl})`);
    const syncDualPhones = ()=>{
        if (!wide.matches) return;
        document.querySelector('.playground-screen-button[data-screen="lock"]')?.click();
    };
    wide.addEventListener("change", syncDualPhones);
    syncDualPhones();
};


// F1: divider bands as live sine paths (same 1592x146 viewBox as the retired
// data-URIs). One shared rAF loop for both waves, frozen off-screen;
// reduced-motion draws a single static frame (F5).
const $92915496fc61abef$var$WAVE_VIEW_W = 1592;
const $92915496fc61abef$var$WAVE_VIEW_H = 146;
const $92915496fc61abef$var$WAVE_STROKES = [
    {
        base: 0.32,
        amp: 0.15,
        periods: 2.0,
        speed: 0.26,
        phase: 0.0
    },
    {
        base: 0.5,
        amp: 0.12,
        periods: 2.0,
        speed: 0.18,
        phase: 2.1
    },
    {
        base: 0.66,
        amp: 0.17,
        periods: 2.0,
        speed: 0.34,
        phase: 4.2
    }
];
const $92915496fc61abef$var$waveY = (stroke, x, mirror, t)=>{
    const breathe = 0.8 + 0.2 * Math.sin(t * 0.23 + stroke.phase);
    const direction = mirror ? -1 : 1;
    // Quarter-period offset so t=0 (first paint, static frame) shows the
    // full shape instead of a flat line.
    const standing = Math.sin(direction * (x / $92915496fc61abef$var$WAVE_VIEW_W) * Math.PI * 2 * stroke.periods + stroke.phase) * Math.sin(t * stroke.speed + Math.PI / 2 + stroke.phase);
    return (stroke.base + stroke.amp * breathe * standing) * $92915496fc61abef$var$WAVE_VIEW_H;
};
const $92915496fc61abef$export$eb9a6b8cf5309dcd = ()=>{
    const svgs = [
        ...document.querySelectorAll(".wave-svg")
    ];
    if (svgs.length === 0) return;
    const waves = svgs.map((svg)=>({
            element: svg.closest(".wave"),
            paths: [
                ...svg.querySelectorAll(".wave-stroke")
            ],
            mirror: svg.closest("#wave-2") !== null
        })).filter((wave)=>wave.paths.length === $92915496fc61abef$var$WAVE_STROKES.length);
    if (waves.length === 0) return;
    const draw = (t)=>{
        waves.forEach((wave)=>{
            wave.paths.forEach((path, i)=>{
                const stroke = $92915496fc61abef$var$WAVE_STROKES[i];
                let d = "";
                for(let x = 0; x <= $92915496fc61abef$var$WAVE_VIEW_W; x += 8)d += (x === 0 ? "M" : "L") + x + " " + $92915496fc61abef$var$waveY(stroke, x, wave.mirror, t).toFixed(1);
                path.setAttribute("d", d);
            });
        });
    };
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        draw(0);
        return;
    }
    let rafId = 0;
    const visible = ()=>waves.some((wave)=>wave.element === null || !wave.element.classList.contains("is-paused"));
    const frame = (now)=>{
        draw(now / 1000);
        rafId = visible() ? window.requestAnimationFrame(frame) : 0;
    };
    const updateLoop = ()=>{
        if (visible() && rafId === 0) rafId = window.requestAnimationFrame(frame);
    };
    if ("IntersectionObserver" in window) {
        const freezeOffscreen = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                entry.target.classList.toggle("is-paused", !entry.isIntersecting);
            });
            if (!visible() && rafId !== 0) {
                window.cancelAnimationFrame(rafId);
                rafId = 0;
            }
            updateLoop();
        });
        waves.forEach((wave)=>{
            if (wave.element !== null) freezeOffscreen.observe(wave.element);
        });
    }
    draw(0);
    updateLoop();
};


// Part F motion: clone each showcase wall once so every track is exactly
// twice one set, then enable the loop (row 2 keeps its static stagger).
const $2c16461cd5ceb73a$export$e720186dc1bc4436 = ()=>{
    const showcase = document.getElementById("showcase");
    if (showcase === null || showcase.dataset.motionDuet === "true") return;
    const tracks = showcase.querySelectorAll(".showcase-track");
    if (tracks.length === 0) return;
    tracks.forEach((track)=>{
        const walls = Array.from(track.children).filter((el)=>{
            return el.classList && el.classList.contains("showcase-wall");
        });
        if (walls.length === 0) return;
        walls.forEach((wall)=>{
            const twin = wall.cloneNode(true);
            twin.setAttribute("aria-hidden", "true");
            twin.querySelectorAll("img").forEach((img)=>{
                img.setAttribute("alt", "");
            });
            track.appendChild(twin);
        });
    });
    showcase.dataset.motionDuet = "true";
    showcase.classList.add("motion-duet");
};


// Part F motion: wrap the explore-all button's anonymous text so CSS can
// nudge it with the icon (translate needs an element).
const $90b22272a6d7f244$export$4081c83b913a8769 = ()=>{
    const link = document.querySelector(".other-apps-more-container .other-apps-more");
    if (link === null || link.querySelector(".other-apps-more-text") !== null) return;
    const text = Array.from(link.childNodes).find((node)=>{
        return node.nodeType === 3 && node.textContent.trim().length > 0;
    });
    if (text === undefined) return;
    const span = document.createElement("span");
    span.className = "other-apps-more-text";
    span.textContent = text.textContent;
    link.replaceChild(span, text);
};


// Part F motion: insert one inert glow layer per card (the card pseudos are
// the pin + ring, so the fade needs an element).
const $93da9af19f9d8787$export$2375e376f8ecb23e = ()=>{
    const cards = document.querySelectorAll("#other-apps .other-app-card");
    if (cards.length === 0) return;
    cards.forEach((card)=>{
        if (card.querySelector(".other-app-card-glow") !== null) return;
        const glow = document.createElement("span");
        glow.className = "other-app-card-glow";
        glow.setAttribute("aria-hidden", "true");
        card.insertBefore(glow, card.firstChild);
    });
};


// Part F motion: mirror each question's text into data-q, the text source
// for the open-state gradient title layer.
const $a89c0490c776223d$export$5cf9e87702ae1f49 = ()=>{
    const questions = document.querySelectorAll("#faq .faq-mnt-q");
    if (questions.length === 0) return;
    questions.forEach((question)=>{
        if (question.hasAttribute("data-q")) return;
        question.setAttribute("data-q", question.textContent);
    });
};


const $c07326a93d728f24$var$main = ()=>{
    // Tail batch (D-footer): dynamic copyright year (progressive enhancement —
    // static fallback in HTML).
    const year = document.querySelector("#copyright-year");
    if (year !== null) year.textContent = String(new Date().getFullYear());
    // Slice 2: no steps section and no auto-cycle anywhere — playground is
    // user-driven only.
    (0, $063969238f3d5243$export$562f18a610c65bb7)();
    // Part F motion: structural one-shots for the ported treatments.
    (0, $2c16461cd5ceb73a$export$e720186dc1bc4436)();
    (0, $90b22272a6d7f244$export$4081c83b913a8769)();
    (0, $93da9af19f9d8787$export$2375e376f8ecb23e)();
    (0, $a89c0490c776223d$export$5cf9e87702ae1f49)();
    // F1 (C2 winner): standing-wave dividers — three sine strokes per wave in
    // the original hues, fixed nodes with breathing amplitude so the shape
    // bobs in place. Wave-2 runs mirrored like the retired art.
    (0, $92915496fc61abef$export$eb9a6b8cf5309dcd)();
};
window.addEventListener("load", $c07326a93d728f24$var$main);


//# sourceMappingURL=wmap.3e527e4b.js.map
